import * as React from 'react'
// components
import { PopoverModal } from 'components/UI'
// icons
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// utils
import { size } from 'polished'

// styled
const DotsIcon = styled(({ margin, iconSize, ...props }) => <DotsIconOrigin {...props} />)<IIconProps>`
  && {
    z-index: 1;
    position: absolute;
    right: 16px;
    top: 6px;
    cursor: pointer;
    ${({ iconSize }) => size(iconSize ? iconSize : '20px')};
  }
`

const Item = styled.div`
  cursor: pointer;
  font-size: 16px;
  margin: 8px 0;
  padding: 5px 15px;

  &:hover {
    background-color: ${colors.gray230};
  }
`

// constants
const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  },
  PaperProps: {
    style: {
      width: '90px'
    }
  }
}

// types
interface IIconProps {
  iconSize?: string
  margin?: string
}

interface IIncomingProps {
  iconSize?: string
  removeField: () => void
}

const DeleteButton: React.FC<IIncomingProps> = ({ iconSize, removeField }) => {
  const handleCLick = (closePopup) => {
    closePopup()
    removeField()
  }

  return (
    <PopoverModal {...MODAL_PROPS} trigger={<DotsIcon data-testid='dots-icon' iconSize={iconSize} />}>
      {({ closePopup }) => (
        <Item data-testid='delete-button' onClick={() => handleCLick(closePopup)}>
          Delete
        </Item>
      )}
    </PopoverModal>
  )
}

export default DeleteButton
